export default __webpack_public_path__ + "static/media/Banner - EarBuddyz PRO - Black.cf5b4e10.jpg";